import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import { Colors } from '../../styles/vars';

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
`;

const HorizontalRule = styled.hr`
  display: block;
  position: relative;
  flex-basis: 0;
  flex-grow: 1;
  min-width: 100px;
  height: 1px;

  background-color: ${props => props.$color || Colors.lighterGrey};
  border: none;
  outline: none;
`;

const Separator = ({ color, style, ruleStyle, children }) => {
  return (
    <Wrapper style={style}>
      <HorizontalRule $color={color} style={ruleStyle} />

      {children && (
        <>
          <div className="children">{children}</div>
          <HorizontalRule className="right" $color={color} />
        </>
      )}
    </Wrapper>
  );
};

Separator.propTypes = {
  color: PropTypes.string,
  style: PropTypes.objectOf(PropTypes.any),
  ruleStyle: PropTypes.objectOf(PropTypes.any),
  children: PropTypes.node,
};

Separator.defaultProps = {
  color: null,
  style: {},
  ruleStyle: {},
  children: null,
};

export default Separator;
